import { render } from "./Xlanji2023.vue?vue&type=template&id=2b3a2ac2&scoped=true"
import script from "./Xlanji2023.vue?vue&type=script&lang=js"
export * from "./Xlanji2023.vue?vue&type=script&lang=js"

import "./Xlanji2023.vue?vue&type=style&index=0&id=2b3a2ac2&scoped=true&lang=css"

import exportComponent from "C:\\ZYSRC\\FW\\fwm_web-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b3a2ac2"]])

export default __exports__